import React from 'react';

import { TopRankIcon } from '~/widgets/knowledge-graph-widget/components/top-rank-icon/TopRankIcon';

import * as S from './ProductCard.styles';

export interface ProductCardProps {
  name: string;
  rank?: number;
  onClick?: () => void;
}

export const ProductCard = ({ name, rank, onClick }: ProductCardProps) => {
  return (
    <S.Root data-testid="product-card" onClick={onClick}>
      <S.TitleLabel data-testid={`${name}-label`}>{name}</S.TitleLabel>
      <S.IconsWrapper>
        {rank && (
          <TopRankIcon
            rank={rank}
            iconSize={24}
            wrapperSize={24}
            rankFontSize={10}
            rankTopPosition="20%"
          />
        )}
      </S.IconsWrapper>
    </S.Root>
  );
};
